module.exports = ".z-smart-actions {\n  padding-left: 20px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/suppliers-barcodes/details-view/order-details-view.style.scss
// module id = ./src/app/suppliers-barcodes/details-view/order-details-view.style.scss
// module chunks = main